(function () {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initCarousel(root) {
    if (!root || root.dataset.collectionCarouselReady === 'true') return;

    var track = root.querySelector('[data-collection-carousel-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-collection-carousel-dot]'));

    if (!track || dots.length === 0) return;

    root.dataset.collectionCarouselReady = 'true';

    function getSlides() {
      return Array.prototype.slice.call(track.children);
    }

    function getStep() {
      var slides = getSlides();
      if (slides.length < 2) return slides[0] ? slides[0].offsetWidth : 1;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    function setActiveDot(index) {
      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function syncDots() {
      var step = getStep();
      if (!step) return;

      var rawIndex = Math.round(track.scrollLeft / step);
      var activeIndex = clamp(rawIndex, 0, dots.length - 1);
      setActiveDot(activeIndex);
    }

    track.addEventListener(
      'scroll',
      function () {
        window.requestAnimationFrame(syncDots);
      },
      { passive: true }
    );

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var targetIndex = Number(dot.dataset.collectionCarouselDot || 0);
        var slides = getSlides();
        if (!slides[targetIndex]) return;

        track.scrollTo({
          left: slides[targetIndex].offsetLeft,
          behavior: 'smooth',
        });
      });
    });

    window.addEventListener('resize', syncDots);
    syncDots();
  }

  function initAllCarousels(container) {
    var scope = container || document;
    scope.querySelectorAll('[data-collection-carousel-root]').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllCarousels(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllCarousels(event.target);
  });
})();
